export const showFile = (file) => {
  const fileURL = URL.createObjectURL(file);
  window.open(fileURL, '_blank');
};
